
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import conf from './../../config/base.js';
import { routerNames, invoiceTitleType } from '@/common/js/const.js';
import { setToken, getToken } from '@/common/js/common.js';
import regexpValid from '@/common/js/regexp.js';
import vconsole from 'vconsole';
import Box from 'vux/src/components/box/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Search from 'vux/src/components/search/index.vue'


export default {

components: {
Box,
Alert,
Group,

Cell,




XHeader,
XButton,
XInput,
XTextarea,
Search,
},
data() {
return {
isWechat: ____isWechatBrowser(),

isDing: ____isDingBrowser(),
__id: '',
userPhoto: '',
userNickName: '我',
userMobilePhone: '',
userEmailAddr: '',

allBinding: false,
showAboutUs: true,
showMobileEmail: true,
showDeppon: false,
showAuthManagement: true,
};
},
created() {},
activated() {
var $self = this;

$self.userMobilePhone = $self.$t('未设置');
$self.userEmailAddr = $self.$t('未设置');

$self.pageLoad(null);
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
/**初始化的时候调用  类似于 ready */
mounted() {
},
methods: {

pageLoad(code) {
var $self = this;
$self.$webapi.getUserInfo().then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
var resData = res.data.result;
if (resData.wxUser) {
$self.userPhoto = resData.wxUser.headimgurl || '';
$self.userNickName = resData.wxUser.nickname || '我';
} else {
$self.userPhoto = '';
$self.userNickName = '我';
}
if (resData.dingUser) {
$self.userPhoto = resData.dingUser.url || '';
$self.userNickName = resData.dingUser.userName || '我';
}
if (resData.xfpUser) {
if (resData.xfpUser.source == 'deppon') {
$self.showDeppon = true;
}
if (resData.xfpUser.source == 'shenhua') {
$self.showMobileEmail = false;
}
$self.__id = resData.xfpUser.id;
$self.userMobilePhone = resData.xfpUser.mobilePhone || $self.$t('未设置');
$self.userEmailAddr = resData.xfpUser.email || $self.$t('未设置');

if ($self.userMobilePhone == '' || $self.userEmailAddr == '') {
$self.allBinding = true;
} else {
$self.allBinding = false;
}
} else {
$self.userMobilePhone = $self.$t('未设置');
$self.userEmailAddr = $self.$t('未设置');
$self.allBinding = false;
}
} else {
$self.userMobilePhone = $self.$t('未设置');
$self.userEmailAddr = $self.$t('未设置');
$self.allBinding = false;
}

});
},

bindEmail() {
var $self = this;
$self.$vux.confirm.prompt(this.$t('请输入邮箱'), {
title: this.$t('设置收票邮箱'),
confirmText: this.$t('确定'),
cancelText: this.$t('取消'),
inputAttrs: {
type: 'email',
},
onShow() {

if (regexpValid.email($self.userEmailAddr)) {
$self.$vux.confirm.setInputValue($self.userEmailAddr);
}
},
onCancel() {},
onConfirm(newVal) {
if (newVal) {
if (regexpValid.email(newVal)) {

$self.$webapi.updateUserEmail(newVal).then(res => {

if (res.data.status == 1) {
$self.userEmailAddr = newVal;

$self.$vux.toast.show({
text: $self.$t('保存成功'),
type: 'text',
});
} else {
$self.$vux.toast.show({
text: res.data.msg,
type: 'text',
});
}
});
} else {
$self.$vux.toast.show({
text: this.$t('表单验证失败提示'),
type: 'text',
});
}
}
},
});












},


bindMobile() {
var $self = this;



},

pageGoBack() {
var $self = this;
try {
if (____isAndroid) {
window.androidApi.backCalls();
} else {

window.iosApi.backCalls();
}
} catch (error) {


$self.$router.replace({
path: '/invoice/create',
});
}
},
toCMS(){
this.$webapi.getCmsUrl(this.__id).then(res => {
if(res.data.status == 1){
location.href = res.data.result
}
})
},
openVConsole(){
if(this.vConsole) {
this.vConsole.destroy();
this.vConsole = null;
}else {
this.vConsole = new vconsole();
}
}
},
};
